export default __webpack_public_path__ + "static/media/Ring-basic.62957dca.mp3";